<template>
  <b-modal :id="idModal" class="modal-info" hide-footer size="sm" scrollable centered>
    <template v-slot:modal-header>
      <div class="modal-info__head modal-info__head--psmall display-flex-center justify-content-between full-width">
        <h4 class="modal-info__title font-sanpro-bold primary-color-txt">Thông tin</h4>
        <span @click="$bvModal.hide(idModal)" class="modal-info__close"><i class="icon-close"></i></span>
      </div>
    </template>
    <div class="modal-info__body primary-color-txt font-sanpro-light bg-color-light p-0">
      <table v-if="dataSource" class="border-0 margin-0 p-0">
        <tr>
          <td class="title secondary-color-txt">Môn học</td>
          <td class="content primary-color-txt">{{ dataSource.subjectName ? dataSource.subjectName : '' }}</td>
        </tr>
        <tr>
          <td class="title secondary-color-txt">Lớp</td>
          <td class="content primary-color-txt">{{ dataSource.className ? dataSource.className.slice(-2) : '' }}</td>
        </tr>
        <tr>
          <td class="title secondary-color-txt">Bộ sách</td>
          <td class="content primary-color-txt">{{ dataSource.bookGroupName ? dataSource.bookGroupName : '' }}</td>
        </tr>
        <tr>
          <td class="title secondary-color-txt">Tác giả</td>
          <td class="content primary-color-txt">{{ dataSource.author ? dataSource.author : '' }}</td>
        </tr>
        <tr>
          <td class="title secondary-color-txt">Bản quyền</td>
          <td class="content primary-color-txt">{{ dataSource.copyrigth ? dataSource.copyrigth : '' }}</td>
        </tr>
        <tr>
          <td class="title secondary-color-txt">Hoàn thành</td>
          <td class="content primary-color-txt">{{ dataSource.completeTime ? dataSource.completeTime : '' }}</td>
        </tr>
      </table>
    </div>
  </b-modal>
</template>

<script>
import { ID_MODAL_EBOOK_LESSON_INFO } from './../../_store/constants'
export default {
  name: 'EbookLessonInfo',
  props: {
    dataSource: Object
  },
  data () {
    return {
      idModal: ID_MODAL_EBOOK_LESSON_INFO
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-info__body {
  .title {
    padding: 5px 10px 5px 0;
  }
  .content {
    padding: 5px 0 5px 10px; 
  }
}
</style>
<style>
  @media screen and (min-width: 576px) {
    #modal_ebook_lesson_info .modal-sm {
      max-width: 420px !important;
    }
  }
</style>
